import React from 'react';
import './Watermark.scss';

const isLocalDev = (): boolean => {
  const url = window.location.href;
  return url.includes('localhost') || url.includes('127.0.0.1');
};

const isWatermarkEnabled = (): boolean => {
  return process.env.REACT_APP_SHOW_WATERMARK === '1';
};

export const Watermark: React.FC = () => {
  if (!isWatermarkEnabled() || !isLocalDev()) {
    return null;
  }

  const watermarkText = `Peacock - localhost`;
  const repeatedText = Array(10).fill(watermarkText).join('   ·   ');

  return <div className="watermark-overlay">{repeatedText}</div>;
};
